import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    nameContainer: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
    },
    buttonBox: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: theme.spacing(1),
    },
    statusLabel: {
        backgroundColor: theme.palette.emteria.primary,
        color: theme.palette.emteria.text.inverse,
        padding: theme.spacing(1, 2),
        borderRadius: 12,
        marginLeft: theme.spacing(1),
    },
    compactCell: {
        paddingTop: 0,
        paddingBottom: 0,
        border: "0px",
    },
    groupRow: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(6),
        height: 50,
        padding: 0,
    },
    groupRowEnd: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(6),
        height: 50,
        justifyContent: "flex-end",
    },
    chevronBox: {
        width: 40,
    },
    groupName: {
        paddingLeft: theme.spacing(6),
    },
}));
